// config.js

const baseB2B_URL = process.env.REACT_APP_BASE_B2B_URL || ""; // eg http://192.168.100.100:8000

const gitAPIKey = "GIT-INFO-1234";
const b2bUsersAPIKey = "B2B-USERS-INFO-1234";
const b2bGenericFwsAPIKey = "B2B-GENERICFW-INFO-1234";

const baseB2B_Images = `https://pwk-sustain-assets.s3.eu-west-1.amazonaws.com/`;

const aesPassKey = "epdsrntr1808epdsrntr1808"; // Same key as backend

export const config = {
    baseB2B_URL,
    gitAPIKey,
    b2bUsersAPIKey,
    b2bGenericFwsAPIKey,
    baseB2B_Images,
    aesPassKey,
};